type EventHandler = (...args: any[]) => void;

const eventHandlers: { [key: string]: EventHandler } = {};

export const addEventListener = (event: string, handler: EventHandler) => {
    eventHandlers[event] = handler;
};

export const removeEventListener = (event: string, handler: EventHandler) => {
    if (!eventHandlers[event]) return;
    delete eventHandlers[event];
};

export const triggerEvent = (event: string, ...args: any[]) => {
    if (!eventHandlers[event]) return;
    eventHandlers[event](...args);
};

export const clearEventHandlers = () => {
    for (const key of Object.keys(eventHandlers)) {
        delete eventHandlers[key];
    }
};

// Добавляем функции в глобальный объект
(window as any).addEventListener = addEventListener;
(window as any).removeEventListener = removeEventListener;
//(window as any).clearEventHandlers = clearEventHandlers;